<script>
export default {
    name: "Home",
}
</script>
<template>
  <tail-base-layout>
      <template v-slot:content>
        <div class="flex flex-wrap mt-4">
                <div class="w-full md:w-1/2 xl:w-1/3 p-3" 
                    v-if="$root.checkAuth('registration.patient-management.index')">
                    <!--Metric Card-->
                    <div class="bg-green-100 border-b-4 border-green-600 rounded-lg shadow-lg p-5">
                        <router-link :to="{ name: `registration.patient-management.index`}">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-2">
                                    <div class="rounded-full p-5 bg-green-600"><i class="fas fa-user-plus fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Patient Registration</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                    <!--/Metric Card-->
                </div>
                <div class="w-full md:w-1/2 xl:w-1/3 p-3"  
                    v-if="$root.checkAuth('outpatient.outpatient-list.index')">
                    <!--Metric Card-->
                    <div class="bg-orange-100 border-b-4 border-orange-500 rounded-lg shadow-lg p-5">
                        <router-link :to="{ name: `outpatient.outpatient-list.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-orange-600"><i class="fas fa-syringe fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Outpatient</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                    <!--/Metric Card-->
                </div>
                <div class="w-full md:w-1/2 xl:w-1/3 p-3" 
                    v-if="$root.checkAuth('inpatients.list.index')">
                    <!--Metric Card-->
                    <div class="bg-yellow-100 border-b-4 border-yellow-600 rounded-lg shadow-lg p-5">
                        <router-link :to="{ name: `inpatients.list.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-yellow-600"><i class="fas fa-procedures fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Inpatients</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                    <!--/Metric Card-->
                </div>
                <div class="w-full md:w-1/2 xl:w-1/3 p-3" 
                    v-if="$root.checkAuth('billing.patients.index')">
                    <!--Metric Card-->
                    <div class="bg-blue-100 border-b-4 border-blue-500 rounded-lg shadow-lg p-5">
                        <router-link :to="{ name: `billing.patients.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-blue-600"><i class="fas fa-hand-holding-usd fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Billing</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                    <!--/Metric Card-->
                </div>
                <div class="w-full md:w-1/2 xl:w-1/3 p-3" 
                    v-if="$root.checkAuth('pharmacy.dashboard')">
                    <!--Metric Card-->
                    <div class="bg-indigo-100 border-b-4 border-indigo-500 rounded-lg shadow-lg p-5">
                        <router-link :to="{ name: `pharmacy.dashboard` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-indigo-600"><i class="fas fa-pills fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Pharmacy</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                    <!--/Metric Card-->
                </div>
                <div class="w-full md:w-1/2 xl:w-1/3 p-3" 
                    v-if="$root.checkAuth('lab.queue.index')">
                    <!--Metric Card-->
                    <div class="bg-red-100 border-b-4 border-red-500 rounded-lg shadow-lg p-5">
                        <router-link :to="{ name: `lab.queue.index`}">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-red-600"><i class="fas fa-microscope fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Lab</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                    <!--/Metric Card-->
                </div>
                <div class="w-full md:w-1/2 xl:w-1/3 p-3">
                    <!--Metric Card-->
                    <div class="bg-indigo-200 border-b-4 border-indigo-700 rounded-lg shadow-lg p-5">
                        <router-link :to="{ name: `profile.statement.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-indigo-600"><i class="fas fa-list fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">My Statement</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                    <!--/Metric Card-->
                </div>
                <div class="w-full md:w-1/2 xl:w-1/3 p-3" 
                    v-if="$root.checkAuth('profile.appointments.index')">
                    <!--Metric Card-->
                    <div class="bg-gray-400 border-b-4 border-gray-700 rounded-lg shadow-lg p-5">
                        <router-link :to="{ name: `profile.appointments.index`}">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-gray-600"><i class="fas fa-tasks fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">My Appointment Schedule</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                    <!--/Metric Card-->
                </div>
                <div class="w-full md:w-1/2 xl:w-1/3 p-3" 
                    v-if="$root.checkAuth('appointments.index')">
                    <!--Metric Card-->
                    <div class="bg-blue-400 border-b-4 border-blue-700 rounded-lg shadow-lg p-5">
                        <router-link :to="{ name: `appointments.index`}">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-blue-600"><i class="fas fa-tasks fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Appointments</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                    <!--/Metric Card-->
                </div>
               
                <div class="w-full md:w-1/2 xl:w-1/3 p-3">
                    <div class="bg-yellow-100 border-b-4 border-yellow-600 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `master-data.hospitaldocuments.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-yellow-600"><i class="fas fa-box-open fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Hospital Documents</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
      </template>
</tail-base-layout>
</template>


